export const USER_ROLE_LABELS = {
  member: '普通成员',
  operations: '运营',
  director: '导演',
  admin: '管理员',
};

export function getUserCapabilities(user) {
  const role = user?.role || 'member';
  const isOperations = role === 'operations';
  const isDirector = role === 'director';
  // Retain the legacy administrator fallback without elevating explicit staff roles.
  const isAdmin = role === 'admin' || (!isOperations && !isDirector && user?.name === '李育东');
  return { isAdmin, isOperations, isDirector, canAccessOperations: isAdmin || isOperations || isDirector };
}

// A login landing preference, not a restriction on subsequent navigation.
export function getLoginLandingPath(user) {
  return user?.role === 'operations' ? '/operations' : '/';
}
